module.exports = __webpack_public_path__ + "img/HQ-OA-360V01TGU.35aad719.jpg";